export const formatDateForInput = (date: Date): string => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const parseDateFromInput = (dateString: string): Date | null => {
  if (!dateString || dateString.length !== 10) return null;
  const [day, month, year] = dateString.split("/");
  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
};

export const formatDateWithMask = (value: string): string => {
  const v = value.replace(/\D/g, "");
  const v2 = v.replace(/(\d{2})(\d)/, "$1/$2");
  const v3 = v2.replace(/(\d{2})(\d)/, "$1/$2");
  return v3;
};
